/**
 * Carousel API keys that map to browse recommendations
 */
export const BROWSE_CAROUSEL_KEYS = ['ready_today_near_you'] as const;

/**
 * Carousel API keys that map to similar vehicle recommendations
 */
export const SIMILAR_VEHICLES_CAROUSEL_KEYS = [
  'recommended-vehicles',
  'you_might_like',
] as const;

/**
 * Maps a carousel API key and pipe-separated stock numbers to the correct
 * analytics metadata field. Centralises the browse / similarVehicles logic so
 * individual transforms don't need to duplicate it.
 */
export const buildRecommendationsObject = (
  carouselKey: string | undefined,
  stockNumbers: number[] | undefined,
): { browse?: string; similarVehicles?: string } => {
  if (!carouselKey || !stockNumbers?.length) return {};
  const joined = stockNumbers.join('|');
  if ((BROWSE_CAROUSEL_KEYS as readonly string[]).includes(carouselKey)) {
    return { browse: joined };
  }
  if (
    (SIMILAR_VEHICLES_CAROUSEL_KEYS as readonly string[]).includes(carouselKey)
  ) {
    return { similarVehicles: joined };
  }
  return {};
};
